/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeRiskClasses.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Risk Class Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 04:45:03 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const RISKCLASS_LIST_CONTAINER_LOADED = 'RISKCLASS_LIST_CONTAINER_LOADED';
export const RISKCLASS_LIST_CONTAINER_UNLOADED = 'RISKCLASS_LIST_CONTAINER_UNLOADED';
export const RISKCLASS_LIST_TABLE_LOADED = 'RISKCLASS_LIST_TABLE_LOADED';
export const RISKCLASS_LIST_TABLE_UNLOADED = 'RISKCLASS_LIST_TABLE_UNLOADED';

export const RISKCLASS_SELECT_ROW = 'RISKCLASS_SELECT_ROW';

export const RISKCLASS_ADD = 'RISKCLASS_ADD';
export const RISKCLASS_EDIT = 'RISKCLASS_EDIT';
export const RISKCLASS_DELETE = 'RISKCLASS_DELETE';
export const RISKCLASS_OPEN_WARNING = 'RISKCLASS_OPEN_WARNING';
export const RISKCLASS_CLOSE_WARNING = 'RISKCLASS_CLOSE_WARNING';

export const RISKCLASS_EDIT_CONTAINER_LOADED = 'RISKCLASS_EDIT_CONTAINER_LOADED';
export const RISKCLASS_EDIT_CONTAINER_UNLOADED = 'RISKCLASS_EDIT_CONTAINER_UNLOADED';
export const RISKCLASS_EDIT_FORM_LOADED = 'RISKCLASS_EDIT_FORM_LOADED';
export const RISKCLASS_EDIT_FORM_UNLOADED = 'RISKCLASS_EDIT_FORM_UNLOADED';

export const RISKCLASS_EDIT_DATA_LOAD = 'RISKCLASS_EDIT_DATA_LOAD';

export const RISKCLASS_EDIT_CONTAINER_SUBMIT = 'RISKCLASS_EDIT_CONTAINER_SUBMIT';
export const RISKCLASS_EDIT_CONTAINER_CANCEL = 'RISKCLASS_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeRiskClasses.js